import { useUserStore } from '@/store/modules/user';

/**
 * 权限指令 v-permission
 * 用法：
 *   <a-button v-permission="'users:create'">新增用户</a-button>
 *   <a-button v-permission="['users:create', 'users:edit']">操作</a-button>
 *
 * 逻辑：
 *   - 传入字符串：拥有该权限则显示，否则移除元素
 *   - 传入数组：拥有任意一个权限则显示（或关系）
 */
export const permission = {
  mounted(el, binding) {
    const userStore = useUserStore();
    const value = binding.value;

    if (!value) return;

    const permissions = Array.isArray(value) ? value : [value];
    const hasAuth = permissions.some(perm => userStore.hasPermission(perm));

    if (!hasAuth) {
      el.parentNode?.removeChild(el);
    }
  },
};

/**
 * 权限指令 v-permission-all
 * 用法：
 *   <a-button v-permission-all="['users:create', 'users:edit']">操作</a-button>
 *
 * 逻辑：拥有所有权限才显示（与关系）
 */
export const permissionAll = {
  mounted(el, binding) {
    const userStore = useUserStore();
    const value = binding.value;

    if (!value) return;

    const permissions = Array.isArray(value) ? value : [value];
    const hasAuth = permissions.every(perm => userStore.hasPermission(perm));

    if (!hasAuth) {
      el.parentNode?.removeChild(el);
    }
  },
};

/**
 * 按钮级权限指令 v-auth
 * 用法：
 *   <a-button v-auth="'product:create'">新增产品</a-button>
 *   <a-button v-auth="['product:edit', 'product:delete']">操作</a-button>
 *   <a-button v-auth:disabled="'product:export'">导出</a-button>
 *
 * 逻辑：
 *   - 默认行为：无权限则移除元素（与 v-permission 一致）
 *   - disabled 修饰符：无权限则禁用元素而非移除（适用于保留布局场景）
 *   - 传入字符串：校验单个权限
 *   - 传入数组：拥有任意一个权限即通过（或关系）
 */
export const auth = {
  mounted(el, binding) {
    const userStore = useUserStore();
    const value = binding.value;
    const isDisabled = binding.arg === 'disabled';

    if (!value) return;

    const permissions = Array.isArray(value) ? value : [value];
    const hasAuth = permissions.some(perm => userStore.hasPermission(perm));

    if (!hasAuth) {
      if (isDisabled) {
        // 禁用模式：设置 disabled 样式和属性
        el.setAttribute('disabled', '');
        el.classList.add('is-disabled');
        el.style.pointerEvents = 'none';
        el.style.opacity = '0.5';
      } else {
        // 默认模式：移除元素
        el.parentNode?.removeChild(el);
      }
    }
  },
};
